import { useContext } from 'react'

import { RealTimeContext } from './context'

export function useRealTime() {
  const context = useContext(RealTimeContext)
  return context
}
